import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ValueForAgents: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            For agents who want to actually grow.
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl">
            Most places give you a contract and wish you luck. We give you everything you need to build something real.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          <div className="bg-slate-50 border border-slate-200 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              Day 1 residuals
            </h3>
            <p className="text-slate-600 text-sm">
              You close a deal, you start earning. No waiting periods, no games. Your money is your money.
            </p>
          </div>

          <div className="bg-slate-50 border border-slate-200 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              Leads that work
            </h3>
            <p className="text-slate-600 text-sm">
              Fresh leads, aged leads, IUL leads, dialer seats. Buy what you need, when you need it. No mandatory minimums.
            </p>
          </div>

          <div className="bg-slate-50 border border-slate-200 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              Training that's actually useful
            </h3>
            <p className="text-slate-600 text-sm">
              Not generic webinars. Real scripts, real objection handling, real strategies from people who are still selling.
            </p>
          </div>

          <div className="bg-slate-50 border border-slate-200 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              CRM and dialer included
            </h3>
            <p className="text-slate-600 text-sm">
              Closio CRM to track everything. Readymode dialer to 3x your call volume. Both come with the territory.
            </p>
          </div>

          <div className="bg-slate-50 border border-slate-200 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              28+ carriers
            </h3>
            <p className="text-slate-600 text-sm">
              Client doesn't qualify? Price too high? You've got 19 other options. More carriers = more closed deals.
            </p>
          </div>

          <div className="bg-slate-50 border border-slate-200 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              People who answer
            </h3>
            <p className="text-slate-600 text-sm">
              Stuck on a case? Need help with an app? Our Discord is active and leadership actually responds.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="bg-navy-800 rounded-2xl p-8 sm:p-10 text-center">
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-3">
            Ready to see if we're a fit?
          </h3>
          <p className="text-navy-200 mb-6 max-w-xl mx-auto">
            No pressure. Fill out an application, we'll talk, and you can decide if this is the right move.
          </p>
          <button
            onClick={() => {
              navigate('/apply');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-navy-800 font-semibold rounded-xl hover:bg-slate-100 transition-colors"
          >
            Apply Now
            <ArrowRight className="h-5 w-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ValueForAgents;
